import React from 'react';

export const DocumentSvg = ({ size = 24, color = '#000' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_140_60282)">
            <mask
                id="mask0_140_60282"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <path d="M0 0H24V24H0V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_140_60282)">
                <path
                    d="M23.0625 16.6094H19.4219C17.8686 16.6094 16.6094 17.8686 16.6094 19.4219V23.0625M23.0625 16.6094C23.0625 17.79 22.5935 18.9221 21.7588 19.7568L19.7568 21.7588C18.9221 22.5935 17.79 23.0625 16.6094 23.0625M23.0625 16.6094V5.63203C23.0625 4.38699 22.5679 3.19289 21.6875 2.31249C20.8071 1.43213 19.613 0.937502 18.368 0.937502H5.63203C4.38698 0.937502 3.19289 1.43213 2.31248 2.31249C1.43213 3.19289 0.9375 4.38699 0.9375 5.63203V18.368C0.9375 19.613 1.43213 20.8071 2.31248 21.6875C3.19289 22.5679 4.38698 23.0625 5.63203 23.0625H15.6875H16.6094M6.46875 17.5313H12M6.46875 6.46875H17.5312M6.46875 12H17.5312"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_140_60282">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const Bell = ({ color = 'black', size = 24 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.49881 16.9969H18.5428C18.9442 16.9969 19.3397 16.9002 19.6959 16.715C20.0521 16.5298 20.3584 16.2615 20.589 15.9329C20.8195 15.6043 20.9675 15.2249 21.0205 14.827C21.0734 14.4291 21.0297 14.0242 20.8931 13.6467L18.5169 7.07727C18.1111 5.61733 17.2383 4.3305 16.0319 3.4136C14.8255 2.49669 13.3519 2.00018 11.8367 2C10.2593 1.99998 8.72901 2.53788 7.49857 3.5249C6.26813 4.51191 5.41107 5.88903 5.0689 7.42887L3.11098 13.7609C2.9957 14.1347 2.96979 14.5304 3.03532 14.9161C3.10085 15.3018 3.25599 15.6667 3.48827 15.9815C3.72055 16.2962 4.02348 16.5521 4.37268 16.7285C4.72188 16.9048 5.1076 16.9968 5.49881 16.9969Z"
            fill={color}
        />
        <path
            d="M8.02495 18.6632C8.21617 19.6049 8.72708 20.4515 9.4711 21.0597C10.2151 21.6678 11.1465 22 12.1074 22C13.0684 22 13.9997 21.6678 14.7438 21.0597C15.4878 20.4515 15.9987 19.6049 16.1899 18.6632H8.02495Z"
            fill={color}
        />
    </svg>
);
export const SuccessIcon = ({ color = 'black', size = 24 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.12 2.039c-1.804.181-3.413.768-4.84 1.767-3.542 2.48-5.102 6.953-3.858 11.059a9.762 9.762 0 0 0 2.517 4.196 9.792 9.792 0 0 0 3.333 2.217c3.362 1.332 7.041.802 9.928-1.433.437-.338 1.307-1.208 1.645-1.645C21.255 16.379 22 14.234 22 12c0-4.568-3.158-8.613-7.57-9.697-.984-.241-2.402-.355-3.31-.264m5.489 6.504c.297.193.405.638.236.964-.046.089-1.307 1.378-3.012 3.08-3.077 3.07-3.013 3.012-3.344 3.013-.242 0-.406-.139-1.842-1.571-.799-.797-1.479-1.5-1.512-1.563-.078-.145-.078-.506-.001-.652a.755.755 0 0 1 .977-.352c.098.041.534.446 1.279 1.189l1.131 1.128 2.632-2.632c2.048-2.048 2.666-2.644 2.789-2.689a.788.788 0 0 1 .667.085"
            fill={color}
        />
    </svg>
);

export const ErrorIcon = ({ color = 'black', size = 24 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.12 2.039c-1.947.195-3.624.848-5.18 2.019a11.51 11.51 0 0 0-1.718 1.661c-3.213 4.021-2.907 9.72.716 13.343a9.96 9.96 0 0 0 14.124 0A9.962 9.962 0 0 0 21.254 8.22c-1.191-2.92-3.786-5.17-6.824-5.917-.984-.241-2.402-.355-3.31-.264m2.229 3.978c.457.208.764.639.799 1.121.02.276-.783 5.741-.892 6.073-.144.438-.562.783-1.054.871a.963.963 0 0 1-.519-.018 1.79 1.79 0 0 1-.385-.145 1.762 1.762 0 0 1-.543-.621c-.096-.218-.92-5.608-.926-6.058-.003-.243.016-.343.099-.525.2-.437.568-.723 1.019-.793.128-.02.665-.033 1.193-.028l.96.009.249.114m-.857 9.451c.271.096.596.398.736.684.098.199.112.275.112.588 0 .431-.078.635-.358.934-.533.57-1.431.57-1.964 0-.28-.299-.358-.503-.358-.934 0-.426.077-.63.345-.921.385-.417.937-.548 1.487-.351"
            fill={color}
        />
    </svg>
);

export const Play = ({ color = '#000', size = 24 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M22 11.9949C22 12.2269 21.8418 12.3123 21.82 12.3283L7.60284 19.9444C7.55101 19.971 7.3928 20.0564 7.20185 19.9417C7 19.827 7 19.6563 7 19.6003V4.39748C7 4.34146 7 4.17073 7.20185 4.05602C7.2755 4.01334 7.3437 4 7.40371 4C7.50191 4 7.58101 4.04268 7.63011 4.06936L21.7927 11.6561C21.8445 11.6854 22 11.7708 22 12.0029V11.9949Z"
            fill={color}
        />
    </svg>
);


export const PauseFill = ({ color = 'black', size = '24' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_110_26482)">
            <path
                d="M12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 5.383 18.617 0 12 0ZM11 16H9V8H11V16ZM15 16H13V8H15V16Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_110_26482">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const User = ({ color = '#000', size = '24' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.04 1.283c-3.059.191-5.695 2.379-6.459 5.359a7.285 7.285 0 0 0-.018 3.569 7.136 7.136 0 0 0 1.9 3.326 7.06 7.06 0 0 0 5.087 2.102c2.627-.003 4.96-1.376 6.287-3.699.385-.675.723-1.696.847-2.56.067-.467.055-1.524-.023-2-.265-1.619-.981-3-2.126-4.101-1.432-1.432-3.404-2.127-5.495-1.996m1.328 1.538c.685.103 1.117.243 1.766.57a5.684 5.684 0 0 1 2.944 3.727c.336 1.419.108 2.97-.618 4.198-1.288 2.18-3.776 3.253-6.219 2.681-2.092-.49-3.75-2.141-4.234-4.217-.462-1.981.138-4.043 1.578-5.423a5.72 5.72 0 0 1 4.783-1.536M10.22 18.084c-1.873.175-3.925.838-5.566 1.8-.716.42-1.712 1.146-2.151 1.567-.296.285-.335.663-.101.986.154.212.326.299.598.3.263.002.312-.026.907-.509 2.816-2.291 6.53-3.187 10.129-2.445.992.204 1.873.511 2.864.996.95.465 1.487.817 2.647 1.737.278.22.47.275.727.206.314-.085.564-.405.564-.722 0-.273-.125-.453-.578-.827a13.681 13.681 0 0 0-7.48-3.093c-.514-.047-2.041-.044-2.56.004"
            fillRule="evenodd"
            fill={color}
        />
    </svg>
);

export const Video = ({ color = '#000', size = '24' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.5.265a11.682 11.682 0 0 0-7.801 3.434C1.698 5.699.526 8.236.282 11.1c-.214 2.51.477 5.191 1.894 7.34a11.21 11.21 0 0 0 1.523 1.861c2 2.001 4.539 3.173 7.401 3.417 1.814.155 3.786-.174 5.54-.925a11.805 11.805 0 0 0 6.153-6.153c.505-1.181.814-2.431.927-3.76.18-2.111-.308-4.433-1.346-6.4-.847-1.607-2.194-3.11-3.734-4.168a11.716 11.716 0 0 0-5.4-1.988A16.063 16.063 0 0 0 11.5.265m1.98 1.595c1.199.187 2.125.483 3.179 1.017 2.206 1.116 3.983 3.081 4.892 5.405.477 1.221.669 2.289.668 3.718-.001.951-.032 1.304-.183 2.06-.594 2.97-2.575 5.604-5.276 7.014A10.035 10.035 0 0 1 12 22.24a10.115 10.115 0 0 1-7.241-2.998c-1.625-1.63-2.587-3.583-2.927-5.942-.068-.475-.068-2.125 0-2.6.184-1.276.493-2.27 1.045-3.359a9.943 9.943 0 0 1 1.881-2.582c1.701-1.695 3.784-2.686 6.222-2.958.483-.054 2.008-.018 2.5.059M9.96 6.278c-.952.126-1.754.843-2.09 1.868l-.09.274v7.16l.09.274c.156.476.363.821.689 1.147.755.755 1.825.956 2.713.51.147-.074 1.321-.844 2.608-1.711 1.689-1.138 2.407-1.644 2.58-1.82.291-.296.506-.653.65-1.08.096-.289.107-.377.107-.9s-.011-.611-.107-.9a2.725 2.725 0 0 0-.651-1.079c-.168-.168-.946-.716-2.58-1.818-1.286-.867-2.456-1.635-2.599-1.706a2.375 2.375 0 0 0-1.32-.219m.611 1.536c.071.03 1.173.758 2.449 1.618 2.479 1.67 2.554 1.73 2.665 2.124.065.234.066.652.001.884-.113.401-.152.433-2.649 2.116-1.285.867-2.394 1.6-2.465 1.63-.442.185-.953-.07-1.196-.596l-.116-.25V8.66l.113-.245c.244-.529.759-.786 1.198-.601"
            fillRule="evenodd"
            fill={color}
        />
    </svg>
);

export const ImageIconSquare = ({ color = '#000', size = '24' }) => (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} xmlns="http://www.w3.org/2000/svg" fill="none">
        <g clipPath={`url(#clip0_40000827_18622)`}>
            <path
                d="M15.6441 17H2.35593C1.60705 17 1 16.3929 1 15.6441V2.35593C1 1.60708 1.60705 1 2.35593 1H15.6441C16.3929 1 17 1.60708 17 2.35593V15.6441C17 16.3929 16.3929 17 15.6441 17Z"
                stroke={color}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M1.10181 13.9153L5.88879 9.12827C6.41832 8.59874 7.27682 8.59874 7.80635 9.12827L10.3899 11.7119L11.6176 10.4842C12.1471 9.95468 13.0056 9.95468 13.5352 10.4842L16.8476 13.7966"
                stroke={color}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M9.94922 5.0678C9.94922 5.81665 10.5563 6.42374 11.3052 6.42374C12.054 6.42374 12.6611 5.81665 12.6611 5.0678C12.6611 4.31896 12.054 3.71187 11.3052 3.71187C10.5563 3.71187 9.94922 4.31896 9.94922 5.0678Z"
                stroke={color}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
        </g>
        <defs>
            <clipPath id="clip0_40000827_18622">
                <rect width={size} height={size} fill="white" />
            </clipPath>
        </defs>
    </svg>
);

